import Component from '@glimmer/component';
import htmlSafe from 'garaje/helpers/html-safe';

export type FillColorString =
  | 'blue'
  | 'blueLighter'
  | 'blueLightest'
  | 'brand'
  | 'grayDark'
  | 'grayDarker'
  | 'grayLighter'
  | 'greenLighter'
  | 'greenLightest'
  | 'newLightBlue'
  | 'orangeLighter'
  | 'orangeLightest'
  | 'pistachio'
  | 'redLighter'
  | 'redLightest';

type SizeString = 'medium' | 'small' | 'xsmall';

interface UiPillSignature {
  Args: {
    fill?: FillColorString;
    size?: SizeString;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLSpanElement;
}

export default class UiPill extends Component<UiPillSignature> {
  get colorClassNames(): string {
    switch (this.args.fill) {
      case 'blue':
        return 'text-white bg-gem-50';
      case 'blueLighter':
        return 'text-white bg-gem-20';
      case 'blueLightest':
        return 'text-gem-50 bg-gem-5';
      case 'newLightBlue':
        return 'text-gem-60 bg-gem-10';
      case 'grayDark':
        return 'text-white bg-carbon-50';
      case 'grayDarker':
        return 'text-white bg-carbon-70';
      case 'grayLighter':
        return 'text-carbon-60 bg-carbon-10';
      case 'redLighter':
        return 'text-red-70 bg-red-40';
      case 'redLightest':
        return 'text-red-60 bg-red-10';
      case 'orangeLighter':
        return 'text-papaya-60 bg-papaya-20';
      case 'orangeLightest':
        return 'text-papaya-60 bg-papaya-10';
      case 'greenLighter':
        return 'text-cilantro-60 bg-cilantro-30';
      case 'greenLightest':
        return 'text-cilantro-60 bg-cilantro-10';
      case 'pistachio':
        return 'text-pistachio-60 bg-pistachio-10';
      case 'brand':
        return 'text-white bg-red-50';
      default:
        return 'border';
    }
  }

  get sizeClasses(): string {
    switch (this.args.size) {
      case 'medium':
        return 'text-xss ml-2';
      case 'small':
        return 'text-xss';
      default:
        return '';
    }
  }

  get baseClassNames(): string {
    return [
      'ml-1 px-2 py-1 inline-block font-bold lining-nums letter-spacing-1 lh-1 align-middle text-xs uppercase nowrap text-center sofia-offset rounded-full',
      this.colorClassNames,
      this.sizeClasses,
    ]
      .filter(Boolean)
      .join(' ');
  }

  get sizeStyles(): string {
    const baseStyles = 'font-weight: 700; padding-top: 3px; padding-bottom: 3px;';
    switch (this.args.size) {
      case 'medium':
        return baseStyles;
      case 'small':
        return baseStyles;
      case 'xsmall':
        return `${baseStyles} padding-left: 6px; padding-right: 6px; font-size: xx-small;`;
      default:
        return '';
    }
  }

  <template>
    <span class={{this.baseClassNames}} style={{if this.sizeStyles (htmlSafe this.sizeStyles)}} ...attributes>
      {{yield}}
    </span>
  </template>
}
